module.exports = __webpack_public_path__ + "8cfd657958a13c491bca6f263affa229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-7.jpg
// module id = 1180
// module chunks = 0